import { DashboardDataDto, normalizeDashboardData } from '../../dto/report';
import api from '../../services/api';

export async function fetchDashboardData(): Promise<DashboardDataDto> {
  const response = await api.get('/reports/dashboard');
  return normalizeDashboardData(response.data);
}
